import { render, staticRenderFns } from "./Ticketing.vue?vue&type=template&id=c65dc55a&scoped=true&lang=pug&"
import script from "./Ticketing.vue?vue&type=script&lang=js&"
export * from "./Ticketing.vue?vue&type=script&lang=js&"
import style0 from "./Ticketing.vue?vue&type=style&index=0&id=c65dc55a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65dc55a",
  null
  
)

export default component.exports